// @flow
import type { Store } from 'effector'
import { domain } from './domain'
import { showUpdaterPopup, hideUpdaterPopup } from './events'

const $showUpdater: Store<boolean> = domain.createStore(false)

$showUpdater.on(showUpdaterPopup, () => true)
$showUpdater.on(hideUpdaterPopup, () => false)

export { $showUpdater }
